export function buildContentRevision({
  pageId,
  pageVersionId,
  pageVersionUpdatedAt,
}: {
  pageId: string;
  pageVersionId: string | null;
  pageVersionUpdatedAt?: string;
}): string {
  return `${pageId}:${pageVersionId || 'none'}:${pageVersionUpdatedAt || 'unknown'}`;
}
